import { PropsWithChildren } from 'react'
import { createGenericContext } from '@/Shared/ui/createGenericContext'
import { HelpCenterRepository } from '@/HelpCenter/domain/HelpCenterRepository'
import { IUseHelpCenterController, useHelpCenterController } from '../hooks'

type Context = {
  repository: HelpCenterRepository
} & IUseHelpCenterController

type Props = PropsWithChildren & {
  repository: HelpCenterRepository
}

const [useHelpCenter, StateContextProvider] = createGenericContext<Context>()

const HelpCenterProvider = ({ repository, children }: Props): JSX.Element => {
  const controller = useHelpCenterController(repository)
  return (
    <StateContextProvider value={{ repository, ...controller }}>
      {children}
    </StateContextProvider>
  )
}

export { HelpCenterProvider, useHelpCenter }
